import React, { useEffect, useState } from "react";
import classes from "./communication.module.css";
import {
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import comNoDataImg from "../../../Assets/images/NoTeam.png";
import {
  OppositeSortArrawBtnIcons,
  RoundAddIcon,
  SortArrawBtnIcons,
} from "../../../Components/Icons/Icons";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../Components/Pagination";
import { useDispatch, useSelector } from "react-redux";
import FilterButton from "../../../Components/Filters/FilterButton";
import FilterDrawer from "../../../Components/Filters/FilterDrawer";
import CheckboxFilterGroup from "../../../Components/Filters/CheckboxFilterGroup";
import DateRangeFilter from "../../../Components/Filters/DateRangeFilter";
import StatusFilter from "../../../Components/Filters/StatusFilter";
import {
  CompanyNameFilter,
  InvoiceFilterAction,
} from "../../../Redux/actions/filterActions";
import CommunicationListItem from "./communicationListItem";
import { GetCommunicationList } from "../../../Redux/actions/communicationActions";
import { handleSortClick } from "../../../Utilities/commonfunctions";
import { getCompaniesList } from "../../../Redux/actions/customerActions";
import dayjs from "dayjs";

const Communication = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [communicationList, setCommunicationList] = useState(["ghjgj"]);
  const PaginationData = useSelector(
    (state) => state.paginationData.Pagination
  );
  const { rowCount, currentPage } = PaginationData || {};
  const communicationDate = useSelector((state) => state.communicationDate);
  const { sortBy } = useSelector((state) => state.filter);
  const Companies = useSelector((state) => state.customerData);
  const [companiesListitems, setCompaniesListitems] = useState([]);
  const { companiesList } = Companies || {};
  const [filterOpen, setFilterOpen] = useState(false);
  const { selectedCompany, invoice } = useSelector((state) => state.filter);
  const [fromDate, setFromDate] = useState(dayjs().subtract(7, 'day'));
  const [toDate, setToDate] = useState(dayjs());
  const state = [{ startDate: fromDate ? dayjs(fromDate).toDate() : null, endDate: toDate ? dayjs(toDate).toDate() : null, key: "selection" }];

  const activeCount =
    (selectedCompany?.length || 0) + (invoice?.length || 0);
  const handleClearAll = () => {
    dispatch(CompanyNameFilter([]));
    dispatch(InvoiceFilterAction([]));
    setFromDate(dayjs().subtract(7, 'day'));
    setToDate(dayjs());
  };

  useEffect(() => {
    dispatch(getCompaniesList());
  }, [dispatch]);

  useEffect(() => {
    if (companiesList && companiesList.length > 0) {
      getnamesarray();
    }
  }, [companiesList]);

  const getnamesarray = async () => {
    const arr = ["teams", "team_leader", "team_player"];
    const companyNames = await companiesList.map((item) => {
      return item.company_name;
    });
    const uniqueCompanyList = companyNames.filter((value, index, self) => {
      return (
        value !== undefined && value !== "" && self.indexOf(value) === index
      );
    });
    const newarr = [...arr, ...uniqueCompanyList];
    console.log(newarr);
    setCompaniesListitems(newarr);
  };

  // const loading = false;
  const { loading, errorlist, communicationList, totalCount } =
    communicationDate || {};

  useEffect(() => {
    const userEntry = {
      company: selectedCompany,
      status: invoice,
    };
    dispatch(
      GetCommunicationList(currentPage, rowCount, sortBy, userEntry, state)
    );
  }, [
    currentPage,
    rowCount,
    sortBy,
    selectedCompany,
    invoice,
    fromDate,
    toDate,
    dispatch,
  ]);


  return (
    <div>
      {/* {totalCount && totalCount > 0 ? ( */}
      {true ? (
        <div>
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
            <FilterButton
              activeCount={activeCount}
              onClick={() => setFilterOpen(true)}
            />
            <Button
              onClick={() => navigate("/communication/create-notification")}
              variant="contained"
              color="primary"
              startIcon={<RoundAddIcon />}
            >
              Create Notification
            </Button>
          </div>
          <div className={classes.TableContainer}>
            <Table className={classes.MainTable}>
              <TableHead>
                <TableRow className={classes.tableHeadRow}>
                  <TableCell className={classes.tableHeadCell}>
                    <div className={classes.tableHEadercelldiv}>
                      <span> Sent to </span>{" "}
                    </div>
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <div className={classes.tableHEadercelldiv}>
                      <span> Sent on </span>{" "}
                      <span
                        onClick={() =>
                          handleSortClick(dispatch, sortBy, "createdAt")
                        }
                      >
                        {sortBy?.includes("desc") &&
                        sortBy?.includes("createdAt") ? (
                          <OppositeSortArrawBtnIcons />
                        ) : (
                          <SortArrawBtnIcons />
                        )}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <div className={classes.tableHEadercelldiv}>
                      <span> Status </span>
                      <span
                        onClick={() =>
                          handleSortClick(dispatch, sortBy, "delivered")
                        }
                      >
                        {sortBy?.includes("desc") &&
                        sortBy?.includes("delivered") ? (
                          <OppositeSortArrawBtnIcons />
                        ) : (
                          <SortArrawBtnIcons />
                        )}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    <span>Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <td colSpan="9" className="text-center">
                      Loading...
                    </td>
                  </TableRow>
                ) : errorlist ? (
                  <TableRow>
                    <td colSpan="9" className="text-center">
                      {errorlist}
                    </td>
                  </TableRow>
                ) : communicationList && communicationList.length > 0 ? (
                  communicationList.map((item, index) => (
                    <CommunicationListItem key={index} item={item} />
                  ))
                ) : (
                  <TableRow>
                    <td colSpan="9" className="text-center">
                      No Data Found
                    </td>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <FilterDrawer
            open={filterOpen}
            onClose={() => setFilterOpen(false)}
            onClearAll={handleClearAll}
          >
            <CheckboxFilterGroup
              label="Sent To"
              options={companiesListitems}
              selected={selectedCompany}
              action={CompanyNameFilter}
            />
            <DateRangeFilter
              label="Sent On"
              fromLabel="From Date"
              toLabel="To Date"
              from={fromDate}
              to={toDate}
              onFromChange={(val) => setFromDate(val)}
              onToChange={(val) => setToDate(val)}
            />
            <StatusFilter label="Status" selected={invoice} communication={true} />
          </FilterDrawer>
          <Pagination total={totalCount} />
        </div>
      ) : (
        <Paper className={classes.NoDataImagePagePaper}>
          <div className={classes.NoDataImageMindiv}>
            <img src={comNoDataImg} alt="" />
            <Typography className={`${classes.NoDataPageMainText} mb-3 mt-3`}>
              You have not shared any notification with your customers
            </Typography>
            <Button
              onClick={() => navigate("/communication/create-notification")}
              variant="contained"
              color="primary"
              startIcon={<RoundAddIcon />}
            >
              Create Notification
            </Button>
          </div>
        </Paper>
      )}
    </div>
  );
};

export default Communication;
